import { RecommendTypes } from '../constants/urls';
import { Result } from '../interfaces/api/recommendPanel';
import { tl } from '../utils/adobeAnalyticsUtil';

/** レコメンドVisible計測 */
export function measureVisibleRecommend(
  recommendType: RecommendTypes,
  results: Result[]
) {
  const totalCount = results.length;
  // IDの配列を作成
  const jids = results.map((recommend) => recommend.itemNo);
  // IDを23個ずつに分ける(最大3セット)
  const EACH_SET = 23;
  const totalSet = Math.min(Math.ceil(totalCount / EACH_SET), 3);
  const jidSet: string[][] = [];
  for (let i = 0; i < totalSet; i += 1) {
    const start = EACH_SET * i;
    const end = EACH_SET * (i + 1);
    const set = jids.slice(start, end);
    jidSet.push(set);
  }
  tl(`recommendVisible:${recommendType}`, {
    linkTrackVars: 'eVar181,eVar182,eVar183,eVar184',
    eVar181: String(totalCount),
    eVar182: jidSet[0] ? jidSet[0].join() : '',
    eVar183: jidSet[1] ? jidSet[1].join() : '',
    eVar184: jidSet[2] ? jidSet[2].join() : '',
  });
}
